'use client';
import { ReactNode, KeyboardEvent } from 'react';
import styles from './campaignbanner.module.scss';

const { cardLink } = styles;

interface LinkWrapperProps {
    children: ReactNode;
    link: {
        href?: string;
        linkText?: string;
    };
}

export default function LinkWrapper({ children, link }: LinkWrapperProps) {
    function handleClick() {
        if (typeof window !== 'undefined' && link?.href) {
            window.location.href = link.href;
        }
    }

    function handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    }

    return (
        <div onClick={handleClick} onKeyDown={handleKeyDown} role="link" tabIndex={0} className={cardLink}>
            {children}
        </div>
    );
}
